<template>
    <div class="item">
        <div class="title_s">{{ $t('popup_user_reservation.label_appointment_date') }}</div>
        <div class="form_s">
            <span class="input_date">
                <span class="sheet_weeks_picker_wrap">
                    <v-icon class="ico_date" @click.stop="action_ShowCalendar">mdi-calendar-blank</v-icon>
                    <input readonly type="text" class="input_xs" :value="dateString" @click.stop="action_ShowCalendar">
                </span>
                <v-date-picker
                    v-if="isShowCalendar"
                    :locale="hospitalLocale"
                    class="sheet_weeks_picker"
                    color="#1F8FE5"
                    v-model="dateString"
                    v-clickoutside:action_HideCalendar="undefined"
                    width="265px"
                    @input="action_SelectDate"
                    :day-format="date=>new Date(date).getDate()">
                </v-date-picker>
            </span>
        </div>
    </div>
</template>


<script>
export default {
    props: {
        value: String
    },
    data() {
        return {
            dateString: undefined,
            isShowCalendar: false
        }
    },
    watch: {
        value: {
            immediate: true,
            handler: function (newValue) {
                this.dateString = newValue.toString()
            }
        },
        dateString: {
            immediate: true,
            handler: function (newValue) {
                this.action_HideCalendar()
                this.$emit('input', newValue.toString())
            }
        }
    },
    methods: {
        action_SelectDate() {

        },
        action_ShowCalendar() {
            this.isShowCalendar = true
        },
        action_HideCalendar() {
            this.isShowCalendar = false
        }
    }
}
</script>